export default __webpack_public_path__ + "static/media/home-preview-software.62ecd8a6.jpg";